<template>
    <div>
        <CDataTable
        :items="this.playerList"
        :fields="[{key:'team_name', label:''}, {key:'last_name', label:'Player'}, {key:'player_id', label:''}, {key:'position', label:''}]"
        hover
        striped
        bordered
        small
        fixed
    >
        <template #team_name="{item}">
        <td>
            <img width="24px" height="32px" :src="'img/team-kits/shirt_' + (item.team_name_short || item.team_name) + '-66.webp'" :alt="item.team_name" />
        </td>
        </template>
        <template #last_name="{item}">
          <TablePlayerItem :item="item" />
        </template>
        <template #player_id="{item}">
          <td>
              <CButton variant="outline" :disabled="isConfirmed(item)" :color="isConfirmed(item) ? 'secondary' : 'primary'" size="sm" :id="item.player_id" @click="confirmPlayer(item, 'keep')">Keep</CButton>
          </td>
        </template>
        <template #position="{item}">
          <td>
              <CButton variant="outline" :disabled="isConfirmed(item) || !dropEnabled" :color="dropEnabled && !isConfirmed(item) ? 'primary' : 'secondary'" size="sm" :id="item.player_id" @click="confirmPlayer(item, 'drop')">Drop</CButton>
          </td>
        </template>
        </CDataTable>
    </div>
</template>

<script>
import TablePlayerItem from '../base/TablePlayerItem.vue';
import { mapState } from 'vuex';

export default {
  name: 'ManageTeam',
  components: { TablePlayerItem },
  data: function() {
    return {confirmedPlayers: []}
  },
  created() {
    if(!this.$store.state.leaderboard.length > 0) {
        this.$store.dispatch("loadLeaderboard");
    }
    this.$store.dispatch("loadClubPlayerConfirmations", {clubId:this.$auth.user['https://tlog-online.co.uk/club_id']});
  },
  computed: {
    playerList: function() {
      var teamArr = [];
        if(this.$store.state.leaderboard.length > 0 && this.$auth.isAuthenticated && Number(this.$auth.user['https://tlog-online.co.uk/club_id']) > 0) {
            var club = this.$store.state.leaderboard.filter(club => club.club_id == this.$auth.user['https://tlog-online.co.uk/club_id'])[0];
            club.players.forEach(element => teamArr.push(element));
            this.$store.state.transfers.bidsPlaced.forEach(element => {
                if(element.status == "win") {
                    teamArr.push({last_name: element.playername, player_id: element.playerid, team_name:element.teamname, position:element.position});
                }
            });
        }
        return teamArr;
      },
      dropEnabled: function() {
        return this.playerList.length > 11;
      },
      ...mapState({confirmedList: state => state.manageTransfers.playerConfirmation})
  },
  watch: {
      confirmedList(newValue, oldValue) {
        var playerIds = [];
        newValue.forEach(element => playerIds.push(element.player_id));
        this.confirmedPlayers = playerIds;
      }
  },
  methods: {
    confirmPlayer: function(player, status) {
      if(this.$auth.isAuthenticated && !this.isConfirmed(player)) {
        player.clubId = this.$auth.user['https://tlog-online.co.uk/club_id'];
        player.status = status;
        this.$store.dispatch("saveClubPlayerConfirmation", player);
      }
    },
    isConfirmed: function(item) {
        return this.confirmedPlayers.indexOf(item.player_id) > -1;
    }
  }
}
</script>